class MFooter extends HTMLElement {
  constructor() {
    super(), this.init();
  }
  init() {
    const e = this.querySelector(".m-footer--accordion"),
      t = document.querySelector(".m-mobile-sticky-bar");
    e &&
      (MinimogTheme.config.mqlMobile &&
        (this.acc = new MinimogLibs.Accordion(e, {
          presetContentHeight: !0,
          onload: !0,
        })),
      document.addEventListener("matchMobile", () => {
        this.acc = new MinimogLibs.Accordion(e, {
          presetContentHeight: !0,
          onload: !0,
        });
      })),
      t &&
        (document.documentElement.style.setProperty(
          "--mobile-sticky-bar-height",
          `${t.offsetHeight}px`
        ),
        document.addEventListener("matchMobile", () => {
          document.documentElement.style.setProperty(
            "--mobile-sticky-bar-height",
            `${t.offsetHeight}px`
          );
        }),
        document.addEventListener("unmatchMobile", () => {
          document.documentElement.style.setProperty(
            "--mobile-sticky-bar-height",
            `${t.offsetHeight}px`
          );
        }));
  }
}
customElements.define("m-footer", MFooter);
